<template>
    <div class="home">
        <h1 class=".is-text-align-center">Administration</h1>
    </div>
</template>

<script>

export default {
    name: "Dashboard",
    components: {}
};
</script>
<style lang="sass" scoped>
.home
    padding: 5em
</style>
